import { IconProps } from '@models/icons';

function FavoriteAngularFill({ size = 16, color = '#AFA8A5', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path
                d="M14.5747 4.97248C14.2815 4.66418 13.9333 4.41961 13.5502 4.25275C13.167 4.08588 12.7563 4 12.3415 4C11.9268 4 11.5161 4.08588 11.1329 4.25275C10.7497 4.41961 10.4016 4.66418 10.1084 4.97248L9.49985 5.61202L8.89132 4.97248C8.29905 4.35002 7.49576 4.00032 6.65816 4.00032C5.82057 4.00032 5.01728 4.35002 4.42501 4.97248C3.83273 5.59494 3.5 6.43918 3.5 7.31947C3.5 8.19977 3.83273 9.04401 4.42501 9.66647L8.77539 14.2386C9.16954 14.6529 9.83015 14.6529 10.2243 14.2386L14.5747 9.66647C14.868 9.35831 15.1007 8.99243 15.2595 8.58972C15.4183 8.18702 15.5 7.75538 15.5 7.31947C15.5 6.88357 15.4183 6.45193 15.2595 6.04923C15.1007 5.64652 14.868 5.28064 14.5747 4.97248Z"
                fill={color}/>
        </svg>);
}

export default FavoriteAngularFill;
